import React from "react";

interface SectionTitleProps {
  icon: React.ComponentType<{ className?: string }>;
  children: React.ReactNode;
}

export default function SectionTitle({ icon: Icon, children }: SectionTitleProps) {
  return (
    <div className="flex items-center gap-3 text-soft-black dark:text-white">
      <Icon className="h-5 w-5" />
      <h2 className="text-xl md:text-2xl font-exo font-bold tracking-wide">{children}</h2>
    </div>
  );
}